export var AnswersActionTypes;
(function (AnswersActionTypes) {
    AnswersActionTypes["FETCH_ANSWERS_ATTEMPT"] = "FETCH_ANSWERS_ATTEMPT";
    AnswersActionTypes["FETCH_ANSWERS_SUCCESS"] = "FETCH_ANSWERS_SUCCESS";
    AnswersActionTypes["FETCH_ANSWERS_FAILURE"] = "FETCH_ANSWERS_FAILURE";
})(AnswersActionTypes || (AnswersActionTypes = {}));
